// @flow
import {
  FETCH_PERMITTED_ROLES,
  FETCH_PERMITTED_ROLES_SUCCESS,
  FETCH_PERMITTED_ROLES_ERROR,
  FETCH_ALL_USERS,
  FETCH_ALL_USERS_SUCCESS,
  FETCH_ALL_USERS_ERROR,
  INVITE_USER,
  INVITE_USER_SUCCESS,
  INVITE_USER_ERROR,
  UPDATE_USER_ROLES,
  UPDATE_USER_ROLES_SUCCESS,
  UPDATE_USER_ROLES_ERROR,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_ERROR,
} from '../actions/userManagementActions';
import type { UserManagementState } from '../types/State';
import RadioUser from '../../../domain/RadioUser';

const INITIAL_STATE: UserManagementState = {
  fetching: false,
  users: [],
  error: false,
  permittedRoles: {
    fetching: false,
    roles: [],
    error: false,
  },
  userInvitation: {
    sending: false,
    error: false,
  },
  userRoles: {
    sending: false,
    error: false,
  },
  userDeletion: {
    deleting: false,
    error: false,
  },
};

export default (state: UserManagementState = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case FETCH_PERMITTED_ROLES:
      return {
        ...state,
        permittedRoles: {
          ...state.permittedRoles,
          fetching: true,
          error: false,
        },
      };
    case FETCH_PERMITTED_ROLES_SUCCESS:
      return {
        ...state,
        permittedRoles: {
          ...state.permittedRoles,
          fetching: false,
          roles: action.roles,
        },
      };
    case FETCH_PERMITTED_ROLES_ERROR:
      return {
        ...state,
        permittedRoles: {
          ...state.permittedRoles,
          fetching: false,
          error: true,
        },
      };
    case FETCH_ALL_USERS:
      return {
        ...state,
        fetching: true,
        error: false,
      };
    case FETCH_ALL_USERS_SUCCESS:
      return {
        ...state,
        fetching: false,
        users: action.users,
      };
    case FETCH_ALL_USERS_ERROR:
      return {
        ...state,
        fetching: false,
        error: true,
      };
    case INVITE_USER:
      return {
        ...state,
        userInvitation: {
          ...state.userInvitation,
          sending: true,
          error: false,
        },
      };
    case INVITE_USER_SUCCESS: {
      const users = state.users.slice();
      if (users.findIndex(user => user.isSameAs(action.user)) === -1) {
        users.push(action.user);
      }

      return {
        ...state,
        userInvitation: {
          ...state.userInvitation,
          sending: false,
        },
        users: users,
      };
    }
    case INVITE_USER_ERROR:
      return {
        ...state,
        userInvitation: {
          ...state.userInvitation,
          sending: false,
          error: true,
        },
      };
    case UPDATE_USER_ROLES:
      return {
        ...state,
        userRoles: {
          ...state.userRoles,
          sending: true,
          error: false,
        },
      };
    case UPDATE_USER_ROLES_SUCCESS: {
      const users = state.users.slice();
      const updatedUserIndex = users.findIndex((user: RadioUser) => user.isSameAs(action.user));
      users[updatedUserIndex].setRoles(action.roles);

      return {
        ...state,
        users: users,
        userRoles: {
          ...state.userRoles,
          sending: false,
        },
      };
    }
    case UPDATE_USER_ROLES_ERROR:
      return {
        ...state,
        userRoles: {
          ...state.userRoles,
          sending: false,
          error: true,
        },
      };
    case DELETE_USER:
      return {
        ...state,
        userDeletion: {
          ...state.userDeletion,
          deleting: true,
          error: false,
        },
      };
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        userDeletion: {
          ...state.userDeletion,
          deleting: false,
          user: {},
        },
        users: state.users.filter((user: RadioUser) => !user.isSameAs(action.user)),
      };
    case DELETE_USER_ERROR:
      return {
        ...state,
        userDeletion: {
          ...state.userDeletion,
          error: true,
          deleting: false,
          user: {},
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/userManagement/reducers/userManagementReducer.js